import { render, staticRenderFns } from "./CourseDetailed.vue?vue&type=template&id=a7109dee&"
import script from "./CourseDetailed.vue?vue&type=script&lang=js&"
export * from "./CourseDetailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports